// import React, { useState, useEffect } from "react";
// import { Box, TextField, Typography } from "@mui/material";
// import "./Edit.css";   // reuse same CSS

// const EditEngineer = ({ open, onClose, engineer, onSave }) => {
//   const [engineerData, setEngineerData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone_no: "",
//     site_name: "",
//     supervisor_name: ""
//   });

//   const [errors, setErrors] = useState({});
//   const nameRegex = /^[A-Za-z]{2,20}$/;
//   const emailRegex = /^[a-zA-Z0-9._]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;


//   useEffect(() => {
//     if (engineer) {
//       setEngineerData({
//         first_name: engineer.first_name || "",
//         last_name: engineer.last_name || "",
//         email: engineer.email || "",
//         phone_no: engineer.phone_no || "",
//         site_name: engineer.site_name || "",
//         supervisor_name: engineer.supervisor_name || ""
//       });
//     }
//   }, [open,engineer]);

//  const handleChange = (e) => {
//   const { name, value } = e.target;

//   let updatedValue = value;

//   // ✅ First & Last Name (only alphabets, no space, max 10)
//   if (name === "first_name" || name === "last_name") {
//     updatedValue = value
//       .replace(/\s/g, "")          // ❌ remove spaces
//       .replace(/[^A-Za-z]/g, "")   // ❌ remove numbers/special chars
//       .slice(0, 20);               // max 10 chars
//   }

//   // ✅ Email (no starting space)
//   if (name === "email") {
//     updatedValue = value.replace(/^\s/, "");
//   }

//   // ✅ Phone (only digits, must start 6–9)
//   if (name === "phone_no") {
//     updatedValue = value
//       .replace(/\D/g, "")     // only digits
//       .slice(0, 10);

//     // ❌ block invalid first digit
//     if (updatedValue.length === 1 && !/[6-9]/.test(updatedValue)) {
//       updatedValue = "";
//     }
//   }

//   setEngineerData((prev) => ({
//     ...prev,
//     [name]: updatedValue
//   }));

//   // ✅ runtime validation
//   const error = validateField(name, updatedValue);

//   setErrors((prev) => ({
//     ...prev,
//     [name]: error
//   }));
// };

//  const validateField = (name, value) => {
//   let error = "";

//   if (name === "first_name" || name === "last_name") {
//     if (!value) {
//       error = "Required";
//     } else if (!nameRegex.test(value)) {
//       error = "2–20 alphabets only";
//     }
//   }

//   if (name === "email") {
//   if (!value) {
//     error = "Email required";
//   } else if (value.length < 2 || value.length > 50) {
//     error = "Email must be 2–50 characters";
//   } else if (!emailRegex.test(value)) {
//     error = "Invalid email format";
//   }
// }

//   if (name === "phone_no") {
//     if (!value) {
//       error = "Phone required";
//     } else if (!/^[6-9]\d{9}$/.test(value)) {
//       error = "Must be 10 digits & start with 6–9";
//     }
//   }

//   return error;
// };

// const validateForm = () => {
//   const newErrors = {};

//   Object.keys(engineerData).forEach((key) => {
//     const error = validateField(key, engineerData[key]);
//     if (error) newErrors[key] = error;
//   });

//   setErrors(newErrors);

//   return Object.keys(newErrors).length === 0;
// };


// useEffect(() => {
//   if (!open) {
//     setErrors({});
//   }
// }, [open]);


//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     onSave({ ...engineer, ...engineerData });
//   };

//   if (!open) return null;

//   return (
//     <div className="edit-site-modal">
//       <Box
//         component="form"
//         className="edit-site-container edit-site-form"
//         onSubmit={handleSubmit}
//       >
//         <Typography className="edit-site-title">
//           Edit Engineer
//         </Typography>

//         <TextField
//           label="First Name"
//           name="first_name"
//           value={engineerData.first_name}
//           onChange={handleChange}
//           error={!!errors.first_name}
//           helperText={errors.first_name || ""}
//         />

//         <TextField
//           label="Last Name"
//           name="last_name"
//           value={engineerData.last_name}
//           onChange={handleChange}
//           error={!!errors.last_name}
//           helperText={errors.last_name || ""}
//         />

//         <TextField
//           label="Email"
//           name="email"
//           value={engineerData.email}
//           onChange={handleChange}
//           onKeyDown={(e) => {
//               if (e.key === " ") e.preventDefault();
//             }}
//           error={!!errors.email}
//           helperText={errors.email || ""}
//         />

//         <TextField
//           label="Phone Number"
//           name="phone_no"
//           value={engineerData.phone_no}
//           onChange={handleChange}
//           error={!!errors.phone_no}
//           helperText={errors.phone_no || ""}
//         />

//         {/* <TextField
//           label="Assigned Site"
//           name="site_name"
//           value={engineerData.site_name}
//           onChange={handleChange}
//         />

//         <TextField
//           label="Supervisor"
//           name="supervisor_name"
//           value={engineerData.supervisor_name}
//           onChange={handleChange}
//         /> */}

//         <div className="edit-btn-wrapper">
//           <button type="button" className="cancel-btn" onClick={onClose}>
//             Cancel
//           </button>

//           <button type="submit" className="edit-btn">
//             Save Changes
//           </button>
//         </div>
//       </Box>
//     </div>
//   );
// };

// export default EditEngineer;











import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import "./Edit.css";   // reuse same CSS

const EditEngineer = ({ open, onClose, engineer, onSave }) => {
  const [engineerData, setEngineerData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_no: "",
    site_name: "",
    supervisor_name: ""
  });

  const [errors, setErrors] = useState({});
  const nameRegex = /^[A-Za-z]{2,20}$/;
  const emailRegex =
  /^(?!.*\.\.)[a-zA-Z0-9]+([._]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;


  useEffect(() => {
    if (engineer) {
      setEngineerData({
        first_name: engineer.first_name || "",
        last_name: engineer.last_name || "",
        email: engineer.email || "",
        phone_no: engineer.phone_no || "",
        site_name: engineer.site_name || "",
        supervisor_name: engineer.supervisor_name || ""
      });
    }
  }, [open,engineer]);

 const handleChange = (e) => {
  const { name, value } = e.target;

  let updatedValue = value;

  // ✅ First & Last Name (only alphabets, no space, max 10)
  if (name === "first_name" || name === "last_name") {
    updatedValue = value
      .replace(/\s/g, "")          // ❌ remove spaces
      .replace(/[^A-Za-z]/g, "")   // ❌ remove numbers/special chars
      .slice(0, 20);               // max 10 chars
  }

  // ✅ Email (no starting space)
  if (name === "email") {
    updatedValue = value
    .replace(/^\s/, "")   // no starting space
    .replace(/\.{2,}/g, ".").toLowerCase(); // prevent multiple dots
}
  

  // ✅ Phone (only digits, must start 6–9)
  if (name === "phone_no") {
    updatedValue = value
      .replace(/\D/g, "")     // only digits
      .slice(0, 10);

    // ❌ block invalid first digit
    if (updatedValue.length === 1 && !/[6-9]/.test(updatedValue)) {
      updatedValue = "";
    }
  }

  setEngineerData((prev) => ({
    ...prev,
    [name]: updatedValue
  }));

  // ✅ runtime validation
  const error = validateField(name, updatedValue);

  setErrors((prev) => ({
    ...prev,
    [name]: error
  }));
};

 const validateField = (name, value) => {
  let error = "";

  if (name === "first_name" || name === "last_name") {
    if (!value) {
      error = "Required";
    } else if (!nameRegex.test(value)) {
      error = "2–20 alphabets only";
    }
  }

  if (name === "email") {
  if (!value) {
    error = "Email required";
  } else if (value.length < 2 || value.length > 50) {
    error = "Email must be 2–50 characters";
  } else if (!emailRegex.test(value)) {
    error = "Invalid email format";
  }
}

  if (name === "phone_no") {
    if (!value) {
      error = "Phone required";
    } else if (!/^[6-9]\d{9}$/.test(value)) {
      error = "Must be 10 digits & start with 6–9";
    }
  }

  return error;
};

const validateForm = () => {
  const newErrors = {};

  Object.keys(engineerData).forEach((key) => {
    const error = validateField(key, engineerData[key]);
    if (error) newErrors[key] = error;
  });

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};


useEffect(() => {
  if (!open) {
    setErrors({});
  }
}, [open]);


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    onSave({ ...engineer, ...engineerData });
  };

  if (!open) return null;

  return (
    <div className="edit-site-modal">
      <Box
        component="form"
        className="edit-site-container edit-site-form"
        onSubmit={handleSubmit}
      >
        <Typography className="edit-site-title">
          Edit Engineer
        </Typography>

        <TextField
          label="First Name"
          name="first_name"
          value={engineerData.first_name}
          onChange={handleChange}
          error={!!errors.first_name}
          helperText={errors.first_name || ""}
        />

        <TextField
          label="Last Name"
          name="last_name"
          value={engineerData.last_name}
          onChange={handleChange}
          error={!!errors.last_name}
          helperText={errors.last_name || ""}
        />

        <TextField
          label="Email"
          name="email"
          value={engineerData.email}
          onChange={handleChange}
          onKeyDown={(e) => {
              if (e.key === " ") e.preventDefault();
            }}
          error={!!errors.email}
          helperText={errors.email || ""}
        />

        <TextField
          label="Phone Number"
          name="phone_no"
          value={engineerData.phone_no}
          onChange={handleChange}
          error={!!errors.phone_no}
          helperText={errors.phone_no || ""}
        />

        {/* <TextField
          label="Assigned Site"
          name="site_name"
          value={engineerData.site_name}
          onChange={handleChange}
        />

        <TextField
          label="Supervisor"
          name="supervisor_name"
          value={engineerData.supervisor_name}
          onChange={handleChange}
        /> */}

        <div className="edit-btn-wrapper">
          <button type="button" className="cancel-btn" onClick={onClose}>
            Cancel
          </button>

          <button type="submit" className="edit-btn">
            Save Changes
          </button>
        </div>
      </Box>
    </div>
  );
};

export default EditEngineer;